export default "__VITE_ASSET__CtVN0cgu__"